module.exports = __webpack_public_path__ + "static/media/disgust.9fa23e70.jpg";